import React from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_boarding-school-fit/artifacts/5kmsljm9_ESA%20Final%20Logo.png";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-[#FDFCF8]">
      {/* Header */}
      <header className="bg-[#FDFCF8] border-b border-[#E2E8F0] py-4">
        <div className="container mx-auto px-4 md:px-8 max-w-7xl flex items-center justify-between">
          <Link to="/">
            <img src={LOGO_URL} alt="Elite School Advisory" className="h-12 w-auto" />
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 text-[#2B4C7E] hover:text-[#C9A227] transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-4 md:px-8 max-w-4xl py-16">
        <h1
          className="text-3xl md:text-4xl font-semibold text-[#1A202C] mb-8"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Terms of Service
        </h1>

        <div className="prose prose-lg max-w-none text-[#4A5568]">
          <p className="text-sm text-[#4A5568] mb-8">
            Last updated: December 2025
          </p>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              1. Acceptance of Terms
            </h2>
            <p>
              By accessing or using the services of Elite School Advisory, operated by Mindways Consulting Pvt Ltd, New Delhi, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              2. Services Description
            </h2>
            <p>
              Elite School Advisory provides educational consulting and advisory services for families seeking admission to boarding schools. Our services include school shortlisting, test preparation guidance, interview coaching, application support, and related advisory services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              3. Client Responsibilities
            </h2>
            <p className="mb-4">As a client, you agree to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Provide accurate and complete information about your child and educational requirements</li>
              <li>Respond to communications in a timely manner</li>
              <li>Meet agreed-upon deadlines for document submission</li>
              <li>Pay fees as per the agreed engagement terms</li>
              <li>Maintain confidentiality of any proprietary information shared</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              4. No Guarantee of Admission
            </h2>
            <p>
              While we provide expert guidance and support, Elite School Advisory does not and cannot guarantee admission to any school. Admission decisions are made solely by the schools and are beyond our control. Our role is to maximise your child's chances through strategic positioning and thorough preparation.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              5. Fees and Payment
            </h2>
            <p>
              Fees for our services are discussed during the initial consultation and agreed upon before engagement begins. Payment terms are specified in individual service agreements. All fees paid are for advisory services rendered and are subject to the refund policy outlined separately.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              6. Intellectual Property
            </h2>
            <p>
              All materials, strategies, and advice provided by Elite School Advisory are proprietary and intended solely for the use of the engaged client. Reproduction, distribution, or sharing of these materials without written consent is prohibited.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              7. Limitation of Liability
            </h2>
            <p>
              Elite School Advisory shall not be liable for any indirect, incidental, special, or consequential damages arising from the use of our services. Our liability is limited to the fees paid for the specific services in question.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              8. Governing Law
            </h2>
            <p>
              These Terms of Service shall be governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts of New Delhi.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              9. Contact Information
            </h2>
            <p>
              For questions about these Terms of Service, please contact us at:
            </p>
            <p className="mt-4">
              <strong>Elite School Advisory</strong><br />
              Operated by Mindways Consulting Pvt Ltd<br />
              New Delhi, India<br />
              Email: eliteschooladvisory@gmail.com<br />
              Phone: +91 98180 65496
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default TermsOfService;
